function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Tab } from 'react-bootstrap';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { ToolsContent } from 'moduleBaseMenu/components/mobile/ToolsContent';
import { SupportContent } from 'moduleBaseMenu/components/mobile/SupportContent';
import { FaqContent } from 'moduleBaseMenu/components/mobile/FaqContent';

var TabsContent = function TabsContent(_ref) {
  var blocks = _ref.blocks,
      hide = _ref.hide,
      supportInfo = _ref.supportInfo,
      tools = _ref.tools,
      faq = _ref.faq;
  var items = blocks.map(function (block) {
    var menuItems = block.items.map(function (menuItem) {
      return /*#__PURE__*/React.createElement("li", {
        className: "menu-panel-section",
        key: "".concat(block.id, "-").concat(menuItem.label)
      }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, menuItem, {
        onClick: function onClick() {
          hide();
        },
        className: "menu-panel-link container container-lg-fluid"
      })));
    });
    return /*#__PURE__*/React.createElement(Tab.Pane, {
      eventKey: block.id,
      key: block.id
    }, /*#__PURE__*/React.createElement("ul", {
      className: "list-unstyled mb-0"
    }, /*#__PURE__*/React.createElement("li", {
      className: "menu-panel-section"
    }, /*#__PURE__*/React.createElement("span", {
      className: "menu-panel-link py-12p container container-lg-fluid fs-22"
    }, block.label)), menuItems));
  });
  return /*#__PURE__*/React.createElement(Tab.Content, {
    className: "bg-ivory"
  }, items, /*#__PURE__*/React.createElement(ToolsContent, {
    tools: tools,
    hide: hide
  }), /*#__PURE__*/React.createElement(SupportContent, {
    supportInfo: supportInfo
  }), /*#__PURE__*/React.createElement(FaqContent, {
    faq: faq,
    hide: hide
  }));
};

export { TabsContent };